export default __webpack_public_path__ + "static/media/GuideTable.b6ba4f8e.png";